export type RecipeCardVM = {
  id: string; title: string; imageUrl?: string; heroImageUrl?: string;
  totalMinutes: number; calories: number; difficulty: 'easy'|'medium'|'hard';
  tags: string[]; ingredients: string[]; description?: string; cuisine?: string
}

export function toRecipeCardVMFromLegacy(r: any): RecipeCardVM {
  const img = r?.imageUrl || r?.heroImageUrl || r?.image || ''
  const prep = r?.prepTime ?? r?.totalMinutes ?? r?.cookTime ?? r?.readyInMinutes ?? 0
  const cals = r?.calories ?? r?.nutrition?.calories ?? r?.nutritionInfo?.calories ?? 0
  const diff = (r?.difficulty
    ?? (prep ? (prep <= 20 ? 'easy' : prep <= 45 ? 'medium' : 'hard') : 'easy')) as 'easy'|'medium'|'hard'
  const ing = Array.isArray(r?.ingredients) ? r.ingredients.map((i: any) => i?.name || i?.originalName || i).filter(Boolean) : []
  const tags = Array.isArray(r?.tags) ? r.tags : (Array.isArray(r?.dietTags) ? r.dietTags : [])
  const cuisine = r?.cuisine || (Array.isArray(r?.cuisines) ? r.cuisines[0] : undefined)
  return {
    id: String(r?.id), title: r?.title, imageUrl: img, heroImageUrl: r?.heroImageUrl || r?.imageUrl || r?.image || undefined,
    totalMinutes: prep || 0, calories: cals || 0, difficulty: diff, tags, ingredients: ing, description: r?.description || '', cuisine: cuisine || ''
  }
}

export function toRecipeCardVMFromV2(item: { recipe: any }): RecipeCardVM {
  const r = item.recipe
  const prep = r?.prepTime ?? r?.totalMinutes ?? r?.cookTime ?? r?.readyInMinutes ?? 0
  const cals = r?.calories ?? r?.nutrition?.calories ?? r?.nutritionInfo?.calories ?? 0
  const diff = (r?.difficulty ?? (prep ? (prep <= 20 ? 'easy' : prep <= 45 ? 'medium' : 'hard') : 'easy')) as 'easy'|'medium'|'hard'
  return {
    id: String(r?.id),
    title: r?.title,
    imageUrl: r?.imageUrl || r?.heroImageUrl || r?.image || '',
    heroImageUrl: r?.heroImageUrl || r?.imageUrl || r?.image || undefined,
    totalMinutes: prep || 0,
    calories: cals || 0,
    difficulty: diff,
    tags: Array.isArray(r?.tags) ? r.tags : [],
    ingredients: Array.isArray(r?.ingredients) ? r.ingredients.map((i:any)=> i?.name || i).filter(Boolean) : [],
    description: r?.description || '',
    cuisine: r?.cuisine || '',
  }
}

